import QPermissionEditor from './src/permissionEditor'

export default QPermissionEditor;
